import React, { useId } from 'react';
import PropTypes from 'prop-types';
import classes from './checkbox.module.scss';

const Checkbox = ({
  checked, label = '', onChange, disabled, readOnly, className = '', labelMarginLeft = 5,
}) => {
  const uniqId = useId();

  return (
    <div className={`${classes.checkbox_wrapper} ${readOnly ? classes.read_only : ''} ${className}`}>
      <input
        id={`checkbox_id_${uniqId}`}
        type="checkbox"
        className={classes.checkbox_input}
        checked={checked}
        onChange={({ target }) => !readOnly && !disabled && onChange(target.checked)}
        disabled={disabled}
      />

      <label className={classes.checkbox_label} htmlFor={`checkbox_id_${uniqId}`}>
        <span className={classes.checkbox_box} />

        {label && <span style={{ marginLeft: labelMarginLeft }} className={classes.checkbox_text}>{label}</span>}
      </label>
    </div>
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  labelMarginLeft: PropTypes.number,
  disabled: PropTypes.bool,
};

export default Checkbox;
